export function templateHtml(id) {
  return document.getElementById(id)?.innerHTML ?? "";
}

export function activateScripts(container) {
  container.querySelectorAll("script").forEach((original) => {
    const script = document.createElement("script");
    [...original.attributes].forEach((attribute) =>
      script.setAttribute(attribute.name, attribute.value),
    );
    if (original.src) script.async = false;
    else script.textContent = original.textContent;
    original.replaceWith(script);
  });
}
